import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import queryString from 'query-string';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Translate from '@securitize/ui-components/i18n/Translate/Translate';
import './ExitProcess.scss';
import UserData from '../../../../../components/UserData/UserData';
import marketsLogo from '../../../../../assets/img/brand/markets_logo.svg';
import { headerThemes } from '../../../../../utils/constants';

const ExitProcess = ({ theme, className }) => {
  const { search } = useLocation();
  const { fromMarkets } = queryString.parse(search);
  const { securitizeIdUrl } = useSelector(({ issuerConfiguration: { config } }) => config);
  const getLink = () => {
    const content = (
      <>
        <i className="icon-arrow_left font-24 mr-2 text-center" />
        <span className="font-14">
          <Translate translationKey={fromMarkets ? 'Texts.return-to' : 'Texts.go-back'} />
        </span>
      </>
    );

    return fromMarkets
      ? (
        <a
          id="link-exit-process"
          className="exitLink d-flex align-items-center mt-2"
          href={`${securitizeIdUrl}/market`}
        >
          {content}
          <img className="exitLink__markets-logo" src={marketsLogo} width={75} alt="markets logo" />
        </a>
      )
      : (
        <Link to="/opportunities" className="exitLink d-flex align-items-center">
          {content}
        </Link>
      );
  };
  return (
    <div className={classNames('d-flex align-items-center justify-content-between', className, {
      exitProcess__containerDark: theme === headerThemes.DARK,
    })}
    >
      {getLink()}
      <UserData theme={theme} />
    </div>
  );
};

ExitProcess.defaultProps = {
  theme: headerThemes.LIGHT,
  className: undefined,
};

ExitProcess.propTypes = {
  theme: PropTypes.oneOf(Object.keys(headerThemes)),
  className: PropTypes.string,
};

export default ExitProcess;
